<dx-popup [(title)]="reportTitle" [(visible)]="showReportPopup" (onHidden)="onHidden($event)">
    <div *dxTemplate="let data of 'content'">
        <nb-card *ngIf="showError && !loadingVisible" status="danger">
            <nb-card-header>{{ 'RAPPORT.FOUT.TITEL' | translate }}</nb-card-header>
            <nb-card-body>{{ 'RAPPORT.FOUT.TEKST' | translate }}</nb-card-body>
        </nb-card>

        <ngx-extended-pdf-viewer [src]="fileContent" useBrowserLocale="true" [showToolbar]="true"
            [showSidebarButton]="true" [showFindButton]="true" [showPagingButtons]="true" [showZoomButtons]="true"
            [showPresentationModeButton]="true" [showOpenFileButton]="false" [showPrintButton]="true"
            [showDownloadButton]="true" [showBookmarkButton]="false" [showSecondaryToolbarButton]="true"
            [showRotateButton]="false" [showHandToolButton]="false" [showScrollingButton]="false"
            [showSpreadButton]="false" [showPropertiesButton]="false" [filenameForDownload]="fileNameForDownload"
            *ngIf="!showError" (pageRendered)="onPageRendered()" (progress)="onProgress($event)"
            (pdfLoadingFailed)="pdfLoadingFailed($event)" (pdfLoaded)="pdfLoaded($event)"></ngx-extended-pdf-viewer>
    </div>
</dx-popup>

<dx-popup [(visible)]="loadingVisible" [width]="500" [height]="225" [showTitle]="false">
    <p>{{loadingMessage}}</p>
    <div>
        <div class="text-center">
            <dx-load-indicator [visible]="progresValue == 0 "></dx-load-indicator>
        </div>
        <dx-progress-bar [min]="0" [max]="100" [(value)]="progresValue" [showStatus]="true"
            [statusFormat]="formatStatus" [visible]="progresValue > 0"></dx-progress-bar>
    </div>

    <dxi-toolbar-item widget="dxButton" location="after" toolbar="bottom" [options]="{
            text: 'Annuleren',
            type: 'danger',
            onClick: cancel
        }">
    </dxi-toolbar-item>
</dx-popup>